<template>
  <div>
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col
        cols="12"
        class="icon-title word-type pb-4 d-flex justify-space-between"
      >
        <div><icon-pay-detail :width="24" :height="24" />급여명세서</div>
        <v-btn
          elevation="0"
          height="38"
          class="mt-n2 btn-year"
          @click="searchYearSheet = !searchYearSheet"
        >
          {{ currYear }}년
          <v-icon class="ml-1" size="24" color="#9ca3ab"
            >mdi-chevron-right</v-icon
          >
        </v-btn>
      </v-col>
    </v-row>

    <!-- 급여구분 카드 -->
    <pay-card-list
      v-bind:propsYear="currYear"
      v-on:openModal="openModal"
    ></pay-card-list>

    <!---------------------------------------------------------------------------->
    <!-- 조회연도 선택 -->
<!--    <bottom-select-->
<!--      :flag="searchYearSheet"-->
<!--      :list="yearList"-->
<!--      :title="selecttitle"-->
<!--      :sheetHeightObj="searchYearSheetHeight"-->
<!--      @selectItem="selectSearchYear"-->
<!--    ></bottom-select>-->
    <v-bottom-sheet v-if="searchYearSheet" v-model="searchYearSheet">
      <bottom-sheet :title="selecttitle" :default="currYear" :items="yearList" @selectItem="selectSearchYear"></bottom-sheet>
    </v-bottom-sheet>

    <!-- [모달] 급여명세서 상세 -->
    <pay-detail-dialog :payCardParam="payCardParamProps"></pay-detail-dialog>
  </div>
</template>

<script>
/* 급여구분선택 */
import PayCardList from '@/components/pay/PayCardList.vue';
import BottomSelect from '@/components/application/form/BottomSelect.vue';
import PayDetailDialog from '@/components/pay/dialog/PayDetailDialog.vue';
import IconPayDetail from '@/assets/customIcon/IconPayDetail.vue';
import { getYearList } from '@/utils/common/dateUtil';
import dayjs from 'dayjs';
import BottomSheet from "@/components/application/form/BottomSheet.vue";

export default {
  data: () => ({
    searchYearSheet: false,
    selecttitle: '연도선택',
    searchYearSheetHeight: {
      sheet: '336px',
      container: '306px',
    },
    yearList: [],
    currYear: '',
    payCardParamProps: {},
  }),
  methods: {
    /* 조회연도 선택 */
    selectSearchYear(data) {
      this.searchYearSheet = !this.searchYearSheet;

      if (this.currYear != data.codeNm) {
        // 공통 스피너 ON
        this.$store.commit('SPINNER/ON_COMMON_SPINNER');

        this.currYear = data.codeNm;
      }
    },
    openModal(paramObj) {
      this.payCardParamProps = paramObj;
      this.$store.commit('DIALOG/TOGGLE_MODAL', 'pay_detail');
    },
  },
  created() {
    // 공통 스피너 ON
    this.$store.commit('SPINNER/ON_COMMON_SPINNER');

    this.yearList = getYearList();
    this.currYear = dayjs().format('YYYY');
  },
  components: {
    BottomSheet,
    PayCardList,
    BottomSelect,
    PayDetailDialog,
    IconPayDetail,
  },
};
</script>

<style></style>
